import $ from "jquery";
import { AddressInput } from "./../../AddressInput.ts";
var SellContact = /** @class */ (function () {
    function SellContact() {
        var _this = this;
        new AddressInput();
        $(".checkbox-group input:checkbox").on("click", function () {
            _this.requireAtLeastOneCheckbox();
        });
        this.requireAtLeastOneCheckbox();
    }
    SellContact.prototype.requireAtLeastOneCheckbox = function () {
        if ($(".checkbox-group input:checked").length > 0) {
            $(".checkbox-group input:checkbox").each(function (index, el) {
                $(el).removeAttr("required");
            });
        }
        else {
            $(".checkbox-group input:checkbox").each(function (index, el) {
                $(el).attr("required", "required");
            });
        }
    };
    return SellContact;
}());
export { SellContact };
